module.exports = __webpack_public_path__ + "static/media/YF52_11.760b56b5.jpg";